import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a12e5eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "m-5 text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Loading...")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The ZIP asset is now being downloaded and extract. A CSV file will be created when done.", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex flex-row align-items-center justify-content-between my-4" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus fa-fw" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Add message ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-file-excel fa-fw" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Import Excel file ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "d-flex flex-row align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash fa-fw" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Remove selected messages ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash fa-fw" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Remove posted messages ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "table-wrapper" }
const _hoisted_27 = { class: "table table-recent-zips table-borderless" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Message Name / Post time"),
    /*#__PURE__*/_createElementVNode("th", null, "Message"),
    /*#__PURE__*/_createElementVNode("th", null, "Campaign / Account / Direct"),
    /*#__PURE__*/_createElementVNode("th", null, "Image URL")
  ])
], -1))
const _hoisted_29 = {
  key: 0,
  align: "center"
}
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner fa-fw" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 2,
  align: "center"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-success fa fa-envelope fa-fw",
  title: "Message posted"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 3,
  align: "center"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-danger fa fa-exclamation-triangle fa-fw",
  title: "Error while posting message"
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 4 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Name", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Post date", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Post time", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_57 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Campaign", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_61 = ["value"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Account", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_65 = ["value"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Direct", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = ["required", "onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "publish" }, "Publish", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "draft" }, "Draft", -1))
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-spin fa-spinner" }, null, -1))
const _hoisted_74 = { key: 1 }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Image URL", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = ["onUpdate:modelValue", "readonly", "disabled"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-success"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fa fa-paper-plane fa-fw" }),
    /*#__PURE__*/_createTextVNode(" Post selected messages ")
  ])
], -1))
const _hoisted_79 = {
  type: "file",
  class: "form-control",
  ref: "importFile"
}
const _hoisted_80 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_81 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_82 = {
  key: 2,
  class: "progress"
}
const _hoisted_83 = ["aria-valuenow", "aria-valuemax"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.extractAssetDone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.extractAssetDone = false))
                }, "Extract another file")
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentClient) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, clientId) => {
              return (_openBlock(), _createElementBlock("option", {
                key: clientId,
                value: clientId
              }, _toDisplayString(client.clientName), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.currentClient]
          ]),
          (_ctx.currentClient)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("form", {
                  onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.postMessages && _ctx.postMessages(...args)))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addMessage && _ctx.addMessage(...args)))
                      }, _hoisted_15),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary ms-3",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importPopUp = true))
                      }, _hoisted_18)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                      }, "Select all"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark ms-3",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeMessages && _ctx.removeMessages(...args)))
                      }, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark ms-3",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removePostedMessages && _ctx.removePostedMessages(...args)))
                      }, _hoisted_25)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("table", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, messageIdx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: messageIdx,
                            class: _normalizeClass({ selected: message.selected })
                          }, [
                            (message.status === 'editing')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "",
                                    "onUpdate:modelValue": ($event: any) => ((message.selected) = $event)
                                  }, null, 8, _hoisted_30), [
                                    [_vModelCheckbox, message.selected]
                                  ]),
                                  _hoisted_31,
                                  _hoisted_32,
                                  _createElementVNode("span", {
                                    class: "fa fa-trash fa-fw",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.messages.splice(messageIdx, 1))
                                  }, null, 8, _hoisted_33)
                                ]))
                              : (message.status === 'posting')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, _hoisted_36))
                                : (message.status === 'posted')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                      _hoisted_38,
                                      _hoisted_39,
                                      _hoisted_40,
                                      _createElementVNode("span", {
                                        class: "fa fa-trash fa-fw",
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => (_ctx.messages.splice(messageIdx, 1))
                                      }, null, 8, _hoisted_41)
                                    ]))
                                  : (message.status === 'error')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                        _hoisted_43,
                                        _hoisted_44,
                                        _hoisted_45,
                                        _createElementVNode("span", {
                                          class: "fa fa-trash fa-fw",
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (_ctx.messages.splice(messageIdx, 1))
                                        }, null, 8, _hoisted_46)
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_47)),
                            _createElementVNode("td", null, [
                              _hoisted_48,
                              _hoisted_49,
                              _withDirectives(_createElementVNode("input", {
                                required: message.selected,
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => ((message.fields.name.value) = $event),
                                readonly: message.status !== 'editing',
                                disabled: message.status !== 'editing'
                              }, null, 8, _hoisted_50), [
                                [_vModelText, message.fields.name.value]
                              ]),
                              _hoisted_51,
                              _hoisted_52,
                              _withDirectives(_createElementVNode("input", {
                                required: message.selected,
                                type: "date",
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => ((message.fields.posttime.date) = $event),
                                readonly: message.status !== 'editing',
                                disabled: message.status !== 'editing'
                              }, null, 8, _hoisted_53), [
                                [_vModelText, message.fields.posttime.date]
                              ]),
                              _hoisted_54,
                              _hoisted_55,
                              _withDirectives(_createElementVNode("input", {
                                required: message.selected,
                                type: "time",
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => ((message.fields.posttime.time) = $event),
                                readonly: message.status !== 'editing',
                                disabled: message.status !== 'editing'
                              }, null, 8, _hoisted_56), [
                                [_vModelText, message.fields.posttime.time]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("textarea", {
                                required: message.selected,
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => ((message.fields.message.value) = $event),
                                rows: "8",
                                readonly: message.status !== 'editing',
                                disabled: message.status !== 'editing'
                              }, null, 8, _hoisted_57), [
                                [_vModelText, message.fields.message.value]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _hoisted_58,
                              _hoisted_59,
                              (_ctx.clients[_ctx.currentClient] && _ctx.clients[_ctx.currentClient].campaigns)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    required: message.selected,
                                    class: _normalizeClass(["form-select mb-1", {
                                                error: !message.fields.campaign.value && message.fields.campaign.error,
                                            }]),
                                    "onUpdate:modelValue": ($event: any) => ((message.fields.campaign.value) = $event),
                                    readonly: message.status !== 'editing',
                                    disabled: message.status !== 'editing'
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCampaigns, (campaign) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: campaign.campaignId,
                                        value: campaign.campaignId
                                      }, _toDisplayString(campaign.data.name), 9, _hoisted_61))
                                    }), 128))
                                  ], 10, _hoisted_60)), [
                                    [_vModelSelect, message.fields.campaign.value]
                                  ])
                                : _createCommentVNode("", true),
                              _hoisted_62,
                              _hoisted_63,
                              (_ctx.clients[_ctx.currentClient] && _ctx.clients[_ctx.currentClient].accounts)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    required: message.selected,
                                    class: _normalizeClass(["form-select mb-1", {
                                                error: !message.fields.account.value && message.fields.account.error,
                                            }]),
                                    "onUpdate:modelValue": ($event: any) => ((message.fields.account.value) = $event),
                                    readonly: message.status !== 'editing',
                                    disabled: message.status !== 'editing'
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccounts, (account) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: account.accountId,
                                        value: account.accountId
                                      }, _toDisplayString(account.data.name) + " (" + _toDisplayString(account.data.type) + ") ", 9, _hoisted_65))
                                    }), 128))
                                  ], 10, _hoisted_64)), [
                                    [_vModelSelect, message.fields.account.value]
                                  ])
                                : _createCommentVNode("", true),
                              _hoisted_66,
                              _hoisted_67,
                              _withDirectives(_createElementVNode("select", {
                                required: message.selected,
                                class: "form-select",
                                "onUpdate:modelValue": ($event: any) => ((message.fields.direct.value) = $event),
                                readonly: message.status !== 'editing',
                                disabled: message.status !== 'editing'
                              }, _hoisted_71, 8, _hoisted_68), [
                                [_vModelSelect, message.fields.direct.value]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              (message.fields.imageurl.assetId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _hoisted_73,
                                    _createTextVNode(" Retrieving asset URL " + _toDisplayString(message.fields.imageurl.assetId), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                    _hoisted_75,
                                    _hoisted_76,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control image-url",
                                      "onUpdate:modelValue": ($event: any) => ((message.fields.imageurl.value) = $event),
                                      readonly: message.status !== 'editing',
                                      disabled: message.status !== 'editing'
                                    }, null, 8, _hoisted_77), [
                                      [_vModelText, message.fields.imageurl.value]
                                    ]),
                                    _createElementVNode("div", {
                                      style: _normalizeStyle({
                                                    height: '114px',
                                                    margin: '10px 0px',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'contain',
                                                    backgroundImage: 'url(' + message.fields.imageurl.value + ')',
                                                })
                                    }, null, 4)
                                  ]))
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_78
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.importPopUp)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 2,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.importPopUp = false)),
          onConfirm: _ctx.importFile,
          title: "Import Excel File",
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", _hoisted_79, null, 512)
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.postPopUp)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 3,
          onConfirm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.postPopUp = false)),
          title: "Posting Messages",
          "show-footer": !!_ctx.postPopUp.error || _ctx.postPopUp.done,
          "cancel-button": false
        }, {
          default: _withCtx(() => [
            (_ctx.postPopUp.done)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, "All selected messages are posted"))
              : _createCommentVNode("", true),
            (_ctx.postPopUp.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.postPopUp.error), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({ width: Math.round((_ctx.postPopUp.progress / _ctx.postPopUp.messageCount) * 100) + '%' }),
                    "aria-valuenow": _ctx.postPopUp.progress,
                    "aria-valuemin": "0",
                    "aria-valuemax": _ctx.postPopUp.messageCount
                  }, _toDisplayString(Math.round((_ctx.postPopUp.progress / _ctx.postPopUp.messageCount) * 100)) + " % ", 13, _hoisted_83)
                ]))
          ]),
          _: 1
        }, 8, ["show-footer"]))
      : _createCommentVNode("", true)
  ]))
}